module.exports = __webpack_public_path__ + "static/media/contemplar_te_4.9019e44e.jpg";